<script setup lang="ts">
import { onMounted } from 'vue'
import adminApi from '../../../services/admin.service'

const getAdminStats = () => {
    adminApi.getStats()
}

onMounted(() => getAdminStats())
</script>

<template>
    <div>Stats</div>
</template>
